export default class TicketkeeperForm {
    constructor($el) {
        this.$el = $el;

        this.$inputs = this.$el.querySelectorAll('.form__control-container');
        this.$submit = this.$el.querySelector('[data-form-submit]');
        this.$formGroups = this.$el.querySelectorAll('.form__group');

        this.createInputContainer   = this.createInputContainer.bind(this);
        this._isLastInput           = this._isLastInput.bind(this);
        this._isLastFormGroup       = this._isLastFormGroup.bind(this);

        this.$inputs.forEach($inputWrapper => {
            this.createInputContainer($inputWrapper, this._isLastInput($inputWrapper));
        });

        // this.$formGroups.forEach($formGroup => {
        //     if (this._isLastFormGroup($formGroup)) {
        //         $formGroup.classList.remove('form__group');
        //     }
        // });
    }

    createInputContainer($inputWrapper, isLast = false) {
        const $wrapper = document.createElement('span');
        $wrapper.classList.add('input-with-button');

        const $label = $inputWrapper.querySelector('label');
        const $input = $inputWrapper.querySelector('input');
        if ($label && $input) {
            $input.placeholder = $label.textContent.trim();
            $input.classList.remove('form__control');
            $label.classList.add('no-display');
        }

        $input.parentNode.insertBefore($wrapper, $input);
        $wrapper.appendChild($input);

        if (isLast) {
            $wrapper.append(this.$submit);
        }

    }

    /**
     * Check if a given input wrapper is the last one
     *
     * @param $inputWrapper
     * @returns {boolean}
     * @private
     */
    _isLastInput($inputWrapper) {
        return this.$inputs[this.$inputs.length - 1] === $inputWrapper;
    }

    /**
     * Check if a given form group is the last one
     *
     * @param $formGroup
     * @returns {boolean}
     * @private
     */
    _isLastFormGroup($formGroup) {
        return this.$formGroups[this.$formGroups.length - 1] === $formGroup;
    }
}
